import React from 'react';
import Status from 'components/status';

export default function AppVersionStatus({
  app,
  version = null,
  blank = false,
}) {
  const { staged_props } = app;
  const published = version?.published || false;
  const released = version?.released || false;
  const staged =
    staged_props?.version && version?.version === staged_props.version;

  return (
    <>
      <Status
        type={
          published
            ? 'positive'
            : staged
            ? 'warning'
            : released
            ? 'primary'
            : 'muted'
        }
        blank={blank}
      >
        {published
          ? 'Published'
          : staged
          ? 'Staged'
          : released
          ? 'Released'
          : 'Unreleased'}
      </Status>
    </>
  );
}
